module.exports = __webpack_public_path__ + "static/img/manual-13.a9c5e79.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-13.png
// module id = cNyy
// module chunks = 4